import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import ScrollToTop from './utils/ScrollToTop';
import Layout from './components/Layout';
import NotFoundPage from './pages/NotFoundPage';
import ApplyInputPage from './pages/ApplyInputPage';
import ApplyCompletePage from './pages/ApplyCompletePage';
import ApplyEmailPage from './pages/ApplyEmailPage';
import ApplySentPage from './pages/ApplySentPage';
import ApplySetPasswordPage from './pages/ApplySetPasswordPage';
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* リセットCSS */}
      <ScrollToTop />
      <Routes>
        <Route
          element={<Layout theme={theme} />}
        >
          {/* 申込 */}
          <Route path="/" element={<ApplyEmailPage />} />
          <Route path="/apply" element={<ApplyInputPage />} />
          <Route path="/apply/sent" element={<ApplySentPage />} />
          <Route path="/apply/set-password" element={<ApplySetPasswordPage />} />
          <Route path="/apply/complete" element={<ApplyCompletePage />} />
          <Route path="/not-found" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
